module.exports = __webpack_public_path__ + "static/media/field-ui-development.a2ee58b1.svg";